import React, { FC } from 'react';
import { Icon } from '@adsk/alloy-react-icon';

const BuildingConnectedColorfulIcon: FC = () => {
  return (
    <Icon size={21} viewBox="0 0 44 44">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M43.0765 18.5263H36.4036C34.8983 11.6913 28.7974 6.56063 21.5177 6.56063C18.2918 6.56063 15.2998 7.57032 12.8335 9.28632V1.80863C15.4955 0.647263 18.4319 0 21.5177 0C32.4274 0 41.4902 8.052 43.0765 18.5263ZM21.5177 13.1225C26.3137 13.1225 30.2019 17.0107 30.2019 21.8067C30.2019 26.6027 26.3137 30.4909 21.5177 30.4909C16.7205 30.4909 12.8335 26.6027 12.8335 21.8067C12.8335 17.0107 16.7205 13.1225 21.5177 13.1225Z"
        fill="#4DAAA7"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M36.6937 24.3517C35.1884 31.1867 29.0875 36.3174 21.8078 36.3174C13.4003 36.3174 6.56179 29.4777 6.56179 21.0714V5.5C2.51726 9.46 0 14.9762 0 21.0714C0 33.0961 9.78305 42.8792 21.8078 42.8792C32.7175 42.8792 41.7803 34.826 43.3666 24.3517H36.6937"
        fill="#31708F"
      />
    </Icon>
  );
};

export default BuildingConnectedColorfulIcon;
